<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <!--<div
      class="left-side-switch"
      onclick="sideChangeStatus();"
    >
      <i
        class="fa"
        :class="status ? 'fa-angle-double-right':'fa-angle-double-left'"
      ></i>
    </div>-->
    <div>
      <h6
        class="tx-uppercase tx-10 tx-mont tx-spacing-1 mg-t-10 pd-x-10 tx-white-7"
      >
        {{ $t("express.条件筛选") }}
      </h6>
      <div class="mg-t-10 pd-x-10 mg-b-40">
        <div class="mg-b-15 form-group">
          <input
            type="text"
            :placeholder="$t('express.物流名称')"
            class="form-control form-control-dark tx-14"
            v-model.trim="keyLogistics"
            @keyup.enter="filtrate()"
          />
        </div>
        <div class="mg-b-15 form-group">
          <select id="select2Country" class="form-control">
            <option value="">{{ $t("express.选择国家") }}</option>
            <optgroup
              v-for="continent in countrys"
              :key="continent.name"
              :label="continent.name"
            >
              <option
                v-for="country in continent.sub"
                :key="country.code2"
                :value="country.code2"
              >
                {{ country.nameCN }} {{ country.code2 }}
              </option>
            </optgroup>
          </select>
        </div>
        <div class="mg-b-15 form-group">
          <select class="form-control" v-model="keyStatus" @change="filtrate()">
            <option value="">{{ $t("express.全部状态") }}</option>
            <option value="1">{{ $t("express.启用") }}</option>
            <option value="2">{{ $t("express.停用") }}</option>
          </select>
        </div>
      </div>
    </div>
    <button
      class="btn btn-primary btn-block tx-uppercase tx-11 tx-spacing-2 tx-medium"
      @click="filtrate()"
    >
      {{ $t("express.筛 选") }}
    </button>
  </div>
</template>

<script>
export default {
  props: ["status", "countrys", "filterProp"],
  data() {
    return {
      keyStatus: "",
      keyLogistics: "",
      keyCountryCode: "",
    };
  },
  watch: {
    filterProp: {
      handler: function () {
        this.keyStatus = this.filterProp.status;
        this.keyLogistics = this.filterProp.logistics;
        this.keyCountryCode = this.filterProp.countryCode;
        if (!this.keyCountryCode) {
          $("#select2Country").select2().val(null).trigger("change");
        }
      },
      deep: true,
    },
  },
  mounted() {
    $("#select2Country").select2({
      language: "zh-CN",
    });
    $("#select2Country").on("select2:select", (e) => {
      this.keyCountryCode = e.params.data.id;
      this.filtrate();
    });
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
  updated() {
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
  methods: {
    filtrate() {
      this.$emit(
        "filtrate",
        this.keyLogistics,
        this.keyCountryCode,
        this.keyStatus
      );
    },
  },
};
</script>
